import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    billableClickCountAvailable: false,
    billableLeadCountAvailable: false,
    billableLeaseCountAvailable: false,
    totalCost: 0,
    listingInvoices: [],
    propertyDetails: {},
});

const coreProductInvoice = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTIC_AD_PRODUCTS_GET_SUCCESS:
            return assign({}, state, payload);

        case DispatchConstants.ANALYTIC_AD_PRODUCTS_GET_FAIL:
            return state;

        default:
            return state;
    }
};

export default coreProductInvoice;
